import { AsPanel } from '../panels/as-panel.js';
import styleText from './as-step-panel.css?raw';

export class AsStepPanel extends AsPanel {
  static get observedAttributes() {
    return ['label-default-text', 'label-dict-key', 'disabled', 'hide'];
  }

  private static readonly sheet = (() => {
    const sheet = new CSSStyleSheet();
    sheet.replaceSync(styleText);
    return sheet;
  })();

  constructor() {
    super();
    if (this.shadowRoot) {
      this.shadowRoot.adoptedStyleSheets = [
        ...this.shadowRoot.adoptedStyleSheets,
        AsStepPanel.sheet
      ];
    }
  }
}

if (!customElements.get('as-step-panel')) {
  customElements.define('as-step-panel', AsStepPanel);
} else {
  console.warn('as-step-panel already defined');
}
